<template>
  <div>
    <template v-if="reactions.length">
      <template v-for="(reaction, index) in reactions" >
        <div v-if="reaction.customer_id" :class="type === 'question' ? 'position-absolute d-flex align-items-center coolpicker-user-action' : 'position-absolute d-flex align-items-center coolpicker-user-answer-draft-action'">
          <div class="emoji-container d-flex flex-row align-items-center justify-content-center">
            <span class="emoji">{{ reaction.content }}</span>
          </div>
        </div>

        <div v-else :class=" type === 'question' ? 'position-absolute d-flex align-items-center coolpicker-account-action' :
     'position-absolute d-flex align-items-center coolpicker-account-answer-draft-action'">
          <div class="emoji-container d-flex flex-row align-items-center justify-content-center">
            <CustomEmojiPicker
                ref="accountEmojiPicker"
                :exist-reaction="true"
                :allEmojis="emojiDataAll"
                :emojiGroups="emojiGroups"
                :default-emoji="reaction.content"
                @emojiUnicodeAdded="reactionTo($event, false)"
            />
          </div>
        </div>
      </template>
    </template>

    <div v-if="!hasUnassignedReaction" :class=" type === 'question' ? 'position-absolute d-flex align-items-center coolpicker-account-action dd' :
     'position-absolute d-flex align-items-center coolpicker-account-answer-draft-action dd'">
      <div class="emoji-container d-flex flex-row align-items-center justify-content-center">
      <CustomEmojiPicker
          ref="emojiPickerDefault"
          :exist-reaction="false"
          :allEmojis="emojiDataAll"
          :emojiGroups="emojiGroups"
          @emojiUnicodeAdded="reactionTo($event, true)"
      />
      </div>
    </div>
  </div>
</template>

<script>
import { TwemojiPicker } from '@kevinfaguiar/vue-twemoji-picker';
import EmojiAllData from '../../../../../public/documents/emojiList.json';
import EmojiGroups from '../../../../../public/documents/emoji-group.json';
import CustomEmojiPicker from './CustomEmojiPicker.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    coolpicker: TwemojiPicker,
    CustomEmojiPicker
  },
  data() {
    return {
      displayEmoji: '',
      emojiDataAll: EmojiAllData,
      emojiGroups: EmojiGroups,
    };
  },
  props: {
    type:{
      type:String,
      required: true,
      default: 'question',
    },
    reactions: {
      type: Array,
      required: true,
    },
    account: Object,
    customer: Object,
    message: Object,
    defaultEmoji: {
      type: String,
      default: '☺',
    },
  },
  computed: {
    hasUnassignedReaction() {
     const res = this.reactions.some(reaction => !reaction.customer_id || reaction.customer_id === "" || reaction.customer_id === null);

      return res;
    },
  },
  methods: {
    ...mapActions('Reply', ['updateReplyTo', 'sendReaction']),

    async reactionTo(emoji, isDefaultPicker) {
      try {
        const response = await this.sendReaction({
          account: this.account,
          customer: this.customer,
          message: this.message,
          text: emoji,
        });

        const pickerRef = isDefaultPicker ? this.$refs.emojiPickerDefault : this.$refs['accountEmojiPicker']?.[0];

        if (response.status === "success") {
          pickerRef?.updateEmojiState(emoji);
        } else {
          pickerRef?.updateWaiting(false);
        }
      } catch (error) {
        this.$refs[isDefaultPicker ? 'emojiPickerDefault' : 'accountEmojiPicker']?.[0]?.updateWaiting(false);
        console.error("Error sending emoji:", error);
      }
    }
  },
};
</script>

<style scoped>
.emoji-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
